"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRUNCATED_TITLE_LENGTH = exports.PAGES = exports.NAME_MAX_LENGTH = exports.NAME = void 0;
const NAME_MAX_LENGTH = exports.NAME_MAX_LENGTH = 200;
const NAME = exports.NAME = 'report.title';
const PAGES = exports.PAGES = {
  SUCCESS: 'success',
  LOADING: 'loading',
  FORM: 'form'
};
const TRUNCATED_TITLE_LENGTH = exports.TRUNCATED_TITLE_LENGTH = 50;